/**
 * @generated SignedSource<<7d274bb1c7c5c6a89a777eadaea1d09f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreCalendarCreateInput = {
  color: string;
  teamIds: ReadonlyArray<string>;
  title: string;
};
export type CalendarCreateMutation$variables = {
  input: StoreCalendarCreateInput;
};
export type CalendarCreateMutation$data = {
  readonly store: {
    readonly createCalendar: {
      readonly color: string;
      readonly id: string;
      readonly title: string;
    };
  };
};
export type CalendarCreateMutation = {
  response: CalendarCreateMutation$data;
  variables: CalendarCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StoreCalendar",
        "kind": "LinkedField",
        "name": "createCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "11bd79afbc5dbb47a8ef12317d3cb614",
    "id": null,
    "metadata": {},
    "name": "CalendarCreateMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarCreateMutation(\n  $input: StoreCalendarCreateInput!\n) {\n  store {\n    createCalendar(input: $input) {\n      id\n      title\n      color\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb5b463cf9ce265c40e4554283408d85";

export default node;
